<template>
  <span></span>
</template>
<script>
export default {
  name: "Init",
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    const userLang = navigator.language || navigator.userLanguage;
    if (userLang == "fr-Fr") {
      this.$vuetify.lang.current = "fr";
    } else {
      this.$vuetify.lang.current = "en";
    }
    if (this.isMobile()) {
      //this.$router.push("/mainMobile");
      this.$router.push("/waitingMobile");
    } else {
      this.$router.push("/main");
    }
  }
};
</script>
<style scoped></style>
